import {
  Breadcrumbs,
  Link,
  Stack,
  TablePagination,
  Typography,
} from "@mui/material";
import {
  PageTopBar,
  ThreeSlotLayout,
} from "../../../../../common/components/page_top_bar";
import { Header } from "./components/header";
import { StyledDataGrid } from "../../../../../common/components/styled_data_grid";
import { GenerateProjetoColumnDefinition } from "./columns";
import { useMemo } from "react";
import { useProjetoListaViewModel } from "../../viewModels/projeto_lista_view_model";
import { SendMailModal } from "../../../../../common/components/send_email_modal";

import PrimaryButton from "../../../../../common/components/primary_button";
import RefreshButton from "../../../../../common/components/refresh_button";
import DynamicIcon from "../../../../../common/components/dynamic_icon";
import DeleteDialog from "../../../../../common/components/delete_dialog";
import { ProjetoLista } from "../../../domain/models/projetos_Lista";
import { LegendaModal } from "./components/legenda_modal";

export const ProjetosLista = () => {
  const viewModel = useProjetoListaViewModel();

  const columnsDefinition = useMemo(() => {
    return GenerateProjetoColumnDefinition({
      onActionEditar: viewModel.handleProjeto,
      onActionDeletar: viewModel.handleProjetoDeleteOpenState,
      onActionEnviarEmail: viewModel.handleProjetoEmailOpenState,
    });
  }, [
    viewModel.handleProjetoDeleteOpenState,
    viewModel.handleProjeto,
    viewModel.handleProjetoEmailOpenState,
  ]);

  return (
    <>
      <PageTopBar>
        <ThreeSlotLayout
          rightSlot={
            <div className="flex flex-row gap-2">
              <PrimaryButton
                startIcon={
                  <DynamicIcon
                    nameIcon="AddRounded"
                    size={25}
                    className="text-white"
                  />
                }
                onClick={() => viewModel.handleProjeto(null)}
              >
                Novo Projeto
              </PrimaryButton>
            </div>
          }
        />
      </PageTopBar>

      <div className="flex w-full gap-2 flex-col py-2 px-4 mb-20">
        <Breadcrumbs aria-label="breadcrumb" className="cursor-pointer">
          <Link underline="hover" color="inherit">
            Projetos
          </Link>
          <Typography className="text-primary-green">
            Lista de Projetos
          </Typography>
        </Breadcrumbs>

        <div className="flex gap-2 items-center w-full">
          <h1 className="text-3xl font-medium text-black dark:text-white">
            Projetos
          </h1>
          <RefreshButton onClick={viewModel.handleReload} />
        </div>

        <Header
          ddlCliente={viewModel.clienteDropdown}
          ddlCentroCusto={viewModel.centroCustoDropdown}
          contrato={viewModel.filters.contato}
          projeto={viewModel.filters.nomeProjeto}
          idsClientes={viewModel.filters.idCliente}
          idsCentroCusto={viewModel.filters.idCentroCusto}
          onContratoChange={viewModel.handleContatoChange}
          onProjetoChange={viewModel.handleNomeProjetoChange}
          handleIdsClientesChange={viewModel.handleClienteChange}
          handleIdsCentroCustoChange={viewModel.handleCentroCustoChange}
          onClear={viewModel.handleClear}
        />
        <div className="w-[180px]">
          <span
            className="text-[#009C4E] bg-transparent border border-[#009C4E] px-2 py-1 text-sm rounded rounded-base font-semibold cursor-pointer"
            onClick={() => viewModel.handleShowLegenda(true)}
          >
            Legenda
          </span>
        </div>

        <StyledDataGrid
          tableName="Projetos"
          disableColumnMenu={false}
          showToolbar={true}
          disableRowSelectionOnClick={true}
          getRowId={(row: ProjetoLista) => row.IdProjeto}
          columns={columnsDefinition}
          loading={viewModel.loading}
          checkboxSelection={false}
          rows={viewModel.projetoLista}
          rowCount={viewModel.projetoLista.length}
          pageSizeOptions={[10, 25, 50, 100]}
          paginationMode="server"
          paginationModel={{
            page: viewModel.pagination.page,
            pageSize: viewModel.pagination.rowsPerPage,
          }}
          pinnedColumns={{
            right: ["idProjeto"],
          }}
          autoHeight={true}
          textSize="pequeno"
          getRowHeight={() => "auto"}
        />
        <TablePagination
          component="div"
          count={viewModel.pagination.totalItems}
          page={viewModel.pagination.page - 1}
          onPageChange={(_, p) => viewModel.handlePageChange(p)}
          rowsPerPageOptions={[10, 25, 50, 100]}
          rowsPerPage={viewModel.pagination.rowsPerPage}
          onRowsPerPageChange={(e) =>
            viewModel.handleRowsPerPageChange(parseInt(e.target.value))
          }
        />
      </div>

      <SendMailModal
        open={viewModel.openEmailModal}
        loading={viewModel.loading}
        sendTo={viewModel.emailSendTo}
        subject={viewModel.emailSubject}
        attachment={viewModel.emailAttachment}
        body={viewModel.emailBody}
        onClose={() => viewModel.handleProjetoEmailOpenState(null, false)}
        onSubmit={viewModel.handleEmailSubmit}
      />
      <LegendaModal
        open={viewModel.openLegendaModal}
        onClose={() => viewModel.handleShowLegenda(false)}
      />

      <DeleteDialog
        open={viewModel.projetoDeleteModal}
        saving={viewModel.saving}
        title="Você realmente deseja excluir este item?"
        onClose={() => viewModel.handleProjetoDeleteOpenState(null, false)}
        onDelete={() => viewModel.handleProjetoDeleteSubmit()}
      />
    </>
  );
};
